import { render, staticRenderFns } from "./BundleSwiper.vue?vue&type=template&id=60a90e57&scoped=true"
import script from "./BundleSwiper.vue?vue&type=script&lang=js"
export * from "./BundleSwiper.vue?vue&type=script&lang=js"
import style0 from "./BundleSwiper.vue?vue&type=style&index=0&id=60a90e57&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a90e57",
  null
  
)

export default component.exports